// src/pages/Admin/Dashboard/tabs/staffs/index.jsx

import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';

import CustomDataGrid from "../../../../../components/common/CustomDataGrid";
import { staffColumns } from "../../../../../constants/columns/staffColumns";
// import { getAllStaffs } from "../../../../../services/api";
import { adminApi } from "../../../../../services/index";

export default function Staff() {
  const [staffs, setStaffs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchStaffs = async () => {
    try {
      const res = await adminApi.getAllStaffs();
      setStaffs(res?.data?.data);
    } catch {
      setError("Failed to fetch staffs");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStaffs();
  }, []);

  if (error) return <p>{error}</p>;
  return (
    <div className="container-fluid">
      <div className="d-flex justify-content-between mb-3">
        <h2>All Staffs</h2>
        <Link to='/admin-dashboard/staffs/create'><button className="btn btn-primary" style={{height:"50px",width:'150px'}}> + Create Account</button></Link> 
      </div>
      <CustomDataGrid
        rows={staffs}
        columns={staffColumns}
        loading={loading}
        getRowId={(row) => row._id}
      />
    </div>
  );
}
